// Paystack configuration for online admission form purchases.
// Set `publicKey` (pk_live_… or pk_test_…) from the CMS / environment settings.
// Never put the Paystack SECRET key in the website. Verify every transaction server-side
// (Paystack webhook or /transaction/verify) before issuing the form.
export const PAYSTACK_CONFIG = {
  publicKey: "",
  currency: "NGN" as const,
  /** Amount in kobo (₦1 = 100 kobo). 0 means the fee has not been confirmed yet. */
  admissionFormAmountKobo: 0,
  productName: "MCC Admission Form",
};

export const INTAKE_OPTIONS = ["September intake", "January intake", "Fast Track", "Not sure yet"];
export const GRADE_OPTIONS = ["Grade 10", "Grade 11", "Grade 12"];
